module.exports = __webpack_public_path__ + "static/media/il.ad7a2d12.svg";